export class TipoTrigger {
    codigo: number;
    nome: string;
    descricao: string;
}

export class TipoEvento {
    codigo: Number;
    nome: string;
    descricao: string;
}

export class TipoPeriodicidade {
    codigo: number;
    nome: string;
    descricao: string;
}

export class TipoEstado {
    codigo: number;
    descricao: string;
}

export class DiaSemana {
    codigo: Number;
    descricao: string;
}

export class DiaMes {
    codigo: number;
    descricao: string;
}

export class Anos {
    codigo: number;
    descricao: string;
}

export class ScheduleTipoDiaUtil {
    codigo: number;
    descricao: string;
}

export class JanelaCodTipoDiaUtil {
    codigo: number;
    descricao: string;
}

export class ModeloTemplate {
    'codigoTemplate': Array<TipoTemplate>;
}

export class TipoTemplate {
    'cod': 1;
    'nomeCadastro': '';
    'nomeAdministracao': '';
}




// WEBPACK FOOTER //
// ./src/model/constantes.ts